import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot } from '@angular/router'
import { ElderToastService } from '@elderbyte/ngx-starter'
import { EMPTY, Observable } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { WorkCenterType } from './work-center-type'
import { WorkCenterTypeService } from './work-center-type.service'

@Injectable({
  providedIn: 'root',
})
export class WorkCenterTypeResolver {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private typeService = inject(WorkCenterTypeService)
  private toastService = inject(ElderToastService)

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  resolve(route: ActivatedRouteSnapshot): Observable<WorkCenterType> {
    const id = route.paramMap.get('id')

    return this.typeService.findById(id).pipe(
      catchError((err) => {
        this.toastService.error('messages.loading_failed', err)
        return EMPTY
      })
    )
  }
}
